import React from 'react'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { PageHeader } from 'ui'
import { useValue } from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'

export default function NormsPageHeader ({ children }) {
  const department = useValue('department.name')
  const index = useValue('active_index')

  const data = {
    department,
    index
  }

  return (
    <PageHeader
      title={<TranslatedTitle name='title' data={data} />}
      subtitle={<Translation name='subtitle' data={data} />}
    >
      {children}
    </PageHeader>
  )
}
